<template>
	<div class="to-param-item" :class="setClass">
		<div class="to-param-label" :style="labelWidthStyle">
			<div class="to-param-label-text">
				<slot name="label">{{ label }}</slot>
			</div>
		</div>
		<div v-tip="tip" class="to-param-value">
			<div class="to-param-value-text">
				<slot>{{ value }}</slot>
			</div>
		</div>
	</div>
</template>

<script setup>
import { inject, onMounted, onBeforeUnmount, getCurrentInstance, computed } from 'vue'
import { paramItemProps } from './param-item'
import { vTip } from '@touchvue/directives'

defineOptions({
	name: 'ToParamItem',
})

const props = defineProps(paramItemProps)
const instance = getCurrentInstance()

// 获取父组件提供的上下文
const paramContext = inject('toParamContext', null)

const labelWidthStyle = computed(() => {
	const labelWidth = paramContext?.getLabelWidth()
	if (labelWidth) {
		return {
			width: labelWidth + 'em',
		}
	}
	return {
		width: props.labelWidth + 'em',
	}
})

// 计算属性
const setClass = computed(() => {
	const arr = []
	if (props.wrap) {
		arr.push('is-wrap')
	}
	return arr
})

onMounted(() => {
	// 注册到父组件
	if (paramContext) {
		paramContext.registerParamItem(instance)
	}
})

onBeforeUnmount(() => {
	// 从父组件注销
	if (paramContext) {
		paramContext.unregisterParamItem(instance)
	}
})
</script>
